<template>
	<div class="p-24 white-bg radius-8 announcement mb-16" v-if="announcementList.length && $auth.hasPermi('home:announcement-view')">
		<div class="flex flex-align-center">
			<div class="fz-18 font-bold ml-8">公告</div>
		</div>
		<div class="mt-20 content-box">
			<div class="item" v-for="(item, index) in announcementList" :key="index" @click="goToUrl(item.link)">
				<div class="font-h6-regular color-gy-8 cursor-pointer hover">{{ item.title }}</div>
				<div class="yx-color-info">{{ item.date }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAnnouncementList } from '@/api/home';

export default {
	props: {
		platformId: {
			type: Number,
			default: 0,
		},
		deptIds: {
			type: Array,
			default: _ => [],
		},
		authorityId: {
			type: Number,
			default: 0,
		},
	},
	name: '',
	data() {
		return {
			announcementList: [],
		};
	},
	computed: {},
	methods: {
		async getAnnouncementList() {
			const { code, data: { list = [] } = {} } = await getAnnouncementList({
				platform_id: this.platformId,
				deptIds: this.deptIds,
				authority_id: this.authorityId,
			});
			if (code !== 0) return;
			this.announcementList = list;
		},
		goToUrl(path) {
			window.open(path, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.announcement {
	.content-box {
		max-height: 180px;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @color-info;
		}
	}

	.item {
		white-space: nowrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;

		&:nth-child(n + 2) {
			margin-top: 12px;
		}
	}
}
</style>
